/**
 * App.js — Phase 3
 *
 * Changes from Phase 2:
 *  • ThemeProvider swapped from static MUI theme → <HrmsThemeProvider>
 *    (supports dark mode toggle, persists to localStorage)
 *  • CssBaseline moved inside HrmsThemeProvider — remove it here
 *  • Session-expiry banner handled via AuthContext.sessionExpired
 *  • Anti-flicker inline script should be added to public/index.html (see README)
 */

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HrmsThemeProvider } from './context/ThemeContext';
import { AuthProvider }      from './context/AuthContext';
import ProtectedRoute        from './components/ProtectedRoute';
import LoginPage             from './pages/LoginPage';
import MainDashboard         from './pages/MainDashboard';
import LogoutPage            from './pages/LogoutPage';

export default function App() {
  return (
    <HrmsThemeProvider>
      {/* AuthProvider is inside ThemeProvider so login page also gets theming */}
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/"        element={<LoginPage />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <MainDashboard />
              </ProtectedRoute>
            } />
            <Route path="/logout"  element={<LogoutPage />} />
            <Route path="*"        element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </HrmsThemeProvider>
  );
}
